import {IVanService} from "../../domain/leasing/IVanService";
import {LeasingType} from "../../../../../server/src/base/entities/leasing/LeasingType";
import {Leasings} from "../../../../../server/src/base/entities/leasing/Leasings";
import {Vans} from "../../../../../server/src/base/entities/leasing/Vans";
import {Van} from "../../../../../server/src/base/entities/leasing/Van";

export class RemoveDisabledVanDecorator extends IVanService{

    private vanService:IVanService;

    constructor(vanService: IVanService) {
        super();
        this.vanService = vanService;
    }

    public Vans(type: LeasingType): Promise<Vans> {
        return this.vanService.Vans(type).then(vans => {
            let filteredVans:Array<Van> = [];
            for(let van of vans.Value()){
                if(van.enabled){
                    filteredVans.push(van);
                }
            }
            return new Vans(filteredVans);
        })
    }

    public Get(id: string): Promise<Van> {
        return this.vanService.Get(id);
    }

    public Add(van:Van): Promise<void> {
        return this.vanService.Add(van);
    }

    public Disable(vanId: string): Promise<void> {
        return this.vanService.Disable(vanId);
    }

    public Enable(vanId: string): Promise<void> {
        return this.vanService.Enable(vanId);
    }

    public Leasings(): Promise<Leasings> {
        return this.vanService.Leasings();
    }

    public Remove(vanId: string): Promise<void> {
        return this.vanService.Remove(vanId);
    }
}


// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/infrastructure/leasing/RemoveDisabledVanDecorator.ts